import { Stack, Typography } from "@mui/material";
import logo from "../assets/svg/logo-full.svg";
import ContainerLoading from "../components/ContainerLoading";

const Terms = () => (
  <ContainerLoading sx={{ padding: 4 }}>
    <Stack justifyContent="center" width="100%" alignItems="center" my="$6">
      <img
        style={{ maxWidth: "350px", width: "100%", cursor: "pointer" }}
        src={logo}
        onClick={() => window.open("https://fightgo.com.br/")}
        alt="ícone de login"
      />
    </Stack>
    <Typography fontWeight="bold" fontSize="$9" textAlign="center" mt={4}>
      Termos e Condições do Fight GO
    </Typography>{" "}
    <br />
    <Typography>
      A plataforma Fight GO ("Plataforma") é mantida e disponibilizada pela 2F
      Tecnologia Ltda., pessoa jurídica com sede na cidade de São Paulo, estado
      de São Paulo, inscrita no CNPJ sob o nº 54.668.873/0001-04 ("Fight GO"), e
      destina-se exclusivamente à gestão de academias e controle de usuários e
      pagamentos.
    </Typography>{" "}
    <br />
    <Typography>
      Estes Termos de Uso ("Termos") visam regular a utilização da Plataforma,
      que pode ser acessada por meio do endereço eletrônico
      https://fightgo.com.br ("Site") e do aplicativo móvel "Fight GO".
    </Typography>{" "}
    <br />
    <Typography>
      Estes Termos estão disponíveis para acesso a qualquer momento pelos
      usuários, por meio do endereço https://fightgo.com.br.
    </Typography>
    <Typography>
      Ao acessar e se cadastrar no Fight GO, você concorda em cumprir estes
      termos de serviço, todas as leis e regulamentos aplicáveis. Se você não
      concordar com algum desses termos, está proibido de usar ou acessar esta
      plataforma.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      1. Acesso e Utilização da Plataforma{" "}
    </Typography>
    <br />
    <Typography>
      1.1 Cadastro Gratuito: O acesso e a utilização da Plataforma têm caráter
      gratuito, podendo ser cobradas taxas adicionais por serviços especiais ou
      funcionalidades avançadas.
    </Typography>
    <br />
    <Typography>
      1.2 Cadastro do Usuário: A plataforma destina-se exclusivamente à gestão
      de academias de lutas, motivo pelo qual pode-se exigir prévia inscrição ou
      registro dos usuários para acesso. O acesso à Plataforma, seja por meio do
      Site ou Aplicativo, somente será liberado após a criação ou confirmação de
      cadastro existente, mediante o preenchimento de cadastro pelo usuário com
      as seguintes informações requeridas pela Plataforma:
    </Typography>
    <br />
    <Typography style={{ paddingLeft: "16px" }}>
      <ul>
        <li> * Nome completo;</li>
        <br />
        <li> * Data de nascimento;</li> <br />
        <li> * CPF ou outro documento de identificação;</li> <br />
        <li>* Informações de contato, como endereço e telefone;</li> <br />
        <li>
          * Credenciais de acesso (login e senha), que serão pessoais e
          intransferíveis.
        </li>{" "}
        <br />
      </ul>
    </Typography>
    <br />
    <Typography>
      Toda informação fornecida pelo usuário por meio da Plataforma deverá ser
      verdadeira. O usuário garante a autenticidade de todos os dados que
      informar durante o preenchimento dos respectivos formulários.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      2. Utilização Correta da Plataforma{" "}
    </Typography>
    <br />
    <Typography>
      Ao utilizar a Plataforma, você se compromete a respeitar a legislação
      brasileira vigente e não produzir, disponibilizar, divulgar ou transmitir
      qualquer conteúdo que:
    </Typography>
    <br />
    <Typography style={{ paddingLeft: "16px" }}>
      * Seja contrário à legislação brasileira, à moral e aos bons costumes;
      <br /> * Incorpore vírus ou outros elementos que possam causar dano ou
      impedir o normal funcionamento da rede ou de equipamentos informáticos;
      <br /> * Provoque, por suas características, dificuldades no normal
      funcionamento da Plataforma.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      3. Responsabilidades do Usuário{" "}
    </Typography>{" "}
    <br />
    <Typography>
      Você é o único responsável pelo uso que fizer da Plataforma e por qualquer
      conteúdo que inserir.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      4. Comercialização de Serviços pela Plataforma{" "}
    </Typography>{" "}
    <br />
    <Typography>
      Os termos de comercialização de serviços, incluindo preços e prazos, serão
      definidos exclusivamente pela Plataforma e estão sujeitos a mudanças.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      {" "}
      5. Legislação e Foro{" "}
    </Typography>{" "}
    <br />
    <Typography>
      Estes termos serão regidos, interpretados e executados de acordo com as
      Leis da República Federativa do Brasil. Será competente o foro de
      domicílio do usuário no Brasil, para dirimir qualquer dúvida decorrente
      deste instrumento.
    </Typography>
    <br />
    <Typography fontWeight="bold" textAlign="end">
      Atualizado pela última vez em 15 de abril de 2024.{" "}
    </Typography>
  </ContainerLoading>
);

export default Terms;
